import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import axios from "axios";
import moment from "moment";
import constants from "../../utils/constants";
import { MonitoringDTO } from "../../types/Monitoring";

// Flujo estándar vía BFF (como el resto de pantallas), no directo a ms-finanzas.
const ISSUED_INVOICES_MONITORING_URL =
  "/api/billing/issued-invoices-monitoring";
const CANCELLED_INVOICES_MONITORING_URL =
  "/api/billing/cancelled-invoices-monitoring";

const filterUntilToday = (data: MonitoringDTO[]): MonitoringDTO[] => {
  const today = moment().format("YYYY-MM-DD");
  return (data || []).filter(item => item.fecha <= today);
};

/**
 * Monitoreo de facturas emitidas (METADATA SAT - calendario superior).
 */
export const getIssuedInvoicesMonitoring = (year: number): IAction => {
  return {
    type: actionTypes.GET_ISSUED_INVOICES_MONITORING,
    payload: {
      promise: axios
        .get(`${constants.BASE_URL}${ISSUED_INVOICES_MONITORING_URL}`, {
          withCredentials: true,
          params: { year }
        })
        .then(response => filterUntilToday(response.data || []))
    }
  };
};

/**
 * Monitoreo de facturas canceladas (METADATA SAT - calendario inferior).
 */
export const getCancelledInvoicesMonitoring = (year: number): IAction => {
  return {
    type: actionTypes.GET_CANCELLED_INVOICES_MONITORING,
    payload: {
      promise: axios
        .get(`${constants.BASE_URL}${CANCELLED_INVOICES_MONITORING_URL}`, {
          withCredentials: true,
          params: { year }
        })
        .then(response => filterUntilToday(response.data || []))
    }
  };
};
